import { render, staticRenderFns } from "./BackDialog.vue?vue&type=template&id=2645eeda&scoped=true&"
import script from "./BackDialog.vue?vue&type=script&lang=js&"
export * from "./BackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645eeda",
  null
  
)

export default component.exports